// extracted by mini-css-extract-plugin
module.exports = {"content":"style-module--content--31n2R style-module--content--3U38B","album":"style-module--album--CijeD","image":"style-module--image--3S9tF"};